import type { ImageLoadPayload, ImagePosition } from "./types";

interface Props {
  imagePosition: ImagePosition;
  imageSrc: string;
  zIndex: number;
  onLoad?: (payload: ImageLoadPayload) => void;
  onError?: () => void;
}

export default function Image({
  imagePosition,
  imageSrc,
  onLoad,
  onError,
  zIndex,
}: Props) {
  const width = imagePosition.bottomRight.x - imagePosition.topLeft.x;
  const height = imagePosition.bottomRight.y - imagePosition.topLeft.y;
  return (
    <img
      src={imageSrc}
      alt=""
      draggable={false}
      style={{
        position: "absolute",
        left: imagePosition.topLeft.x || 0,
        top: imagePosition.topLeft.y || 0,
        width: Number.isNaN(width) ? 0 : width,
        height: Number.isNaN(height) ? 0 : height,
        zIndex,
        imageRendering: "pixelated",
        userSelect: "none",
        pointerEvents: "none",
      }}
      onLoad={(event) =>
        onLoad?.({
          naturalWidth: event.currentTarget.naturalWidth,
          naturalHeight: event.currentTarget.naturalHeight,
        })
      }
      onError={() => onError?.()}
    />
  );
}
